/// <reference types="./left_arrow.d.mts" />
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $svg from "../../ds/internals/svg.mjs";
import { toList } from "../../gleam.mjs";

export function left_arrow() {
  return $svg.square_(
    20,
    toList([$a.style("transform", "rotate(180deg)")]),
    "<path fill=\"currentColor\" d=\"M13.4766 9.16664L9.00665 4.69664L10.185 3.51831L16.6666 9.99998L10.185 16.4816L9.00665 15.3033L13.4766 10.8333H3.33331V9.16664H13.4766Z\" />",
  );
}
